<template>
  <div class="subase-ger">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cabecalho" v-show="this.cpntRemoverCampos.indexOf('filtros') === -1">
        <App-Filtros
        :cpntMontarCampoF="subaseGerTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="subaseGerTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="subaseGerTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'nome', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='subaseGerTabBuscarLinhas'
        ref="filtros"></App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntSetarFiltros="subaseGerTabSetarFiltros"
        :cpntMontarFiltros="subaseGerTabMontarFiltros"
        :cpntMontarWhere="subaseGerTabTabelaMontarWhere"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntMostrarMper="cpntRemoverCampos.indexOf('mper') === -1"
        :cpntSetarValores="subaseGerTabSetarLinhas"
        :cpntApiTabPer="tabper"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntSalvarEdicao="subaseGerTabEditar"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @cpntSetarStatusLiberado="subaseGerTabSetarStatusLiberado"
        ref="tabela">
          <!-- LOGOTIPO -->
          <template v-slot:col_logo="{ linha }">
            <img :src="linha.logo" :title="linha.clu + ' - ' + linha.cliente" />
          </template>

          <!-- NOME DA EMPRESA -->
          <template v-slot:col_nome="{ linha }">
            <span v-html="linha.cliente"></span>
            <br/>
            <span v-html="linha.cnpj"></span>
          </template>

          <!-- REPRESENTANTE LEGAL -->
          <template v-slot:col_representante="{ linha }">
            <span v-html="linha.rep_leg"></span>
            <br/>
            <span v-html="linha.rep_cpf"></span>
          </template>

          <!-- COLUNA EMAIL -->
          <template v-slot:col_email="{ linha }">
            <span v-html='linha._email'></span>
          </template>

          <!-- COLUNA DATA DE CADASTRO -->
          <template v-slot:col_data_ini_sis="{ linha }">
            <span v-html='linha._data_ini_sis'></span>
          </template>

          <!-- COLUNA CONTRATO -->
          <template v-slot:col_contrato="{ linha }">
            <span v-if="[ '', null, undefined ].indexOf(linha.virtual_contador_free) === -1 && linha.virtual_contador_free === 's'">
              Contador Free
            </span>
            <span v-else-if="[ '', null, undefined ].indexOf(linha.con_lic_data) === -1">
              Licença de uso aceite em <span v-html='linha._con_lic_data'></span>.
            </span>
            <span v-else-if="[ '', null, undefined ].indexOf(linha.con_dem_data) === -1">
              Demonstrativo aceite em <span v-html='linha._con_dem_data'></span>
            </span>
            <span v-else>---</span>
          </template>

          <!-- COLUNA CEP -->
          <template v-slot:col_cep="{ linha }">
            <span v-html="linha._cep"></span>
          </template>

          <!-- COLUNA SITE -->
          <template v-slot:col_site="{ valor }">
            <a v-if="[ '', null, undefined ].indexOf(valor) === -1" :href='valor' target="_blank" class="btn btn-default bt-link-cadastro" v-html="valor"></a>
          </template>

          <!-- COLUNA SITE -->
          <template v-slot:col_ambiente="{ indexL, linha }">
            <div v-for="item in linha._ambiente" :key="'ambiente-' + indexL + '-' + item.modelo">
              <div class="modelo" v-html="item.modelo"></div>
              <div class="ambiente" v-html="item.ambiente"></div>
              <div class="emissor" v-html="item.emissor"></div>
            </div>
          </template>

          <!-- COLUNA OPTANTE PELO SIMPLES -->
          <template v-slot:col_rt_id="{ linha }">
            <span v-if="linha.rt_id === '1'">Simples Nacional</span>
            <span v-else-if="linha.rt_id === '2'">Simples Nacional – excesso de sublimite de receita bruta</span>
            <span v-else-if="linha.rt_id === '3'">
              Regime Normal
              <br/>
              Lucro {{ linha.rt_3_opt === 'p' ? 'Presumido' : 'Real' }}
            </span>
            <span v-else>---</span>
          </template>

          <template v-slot:col_endereco="{ linha }">
            <span v-html='linha.endereco'></span>
            <span v-html='" , "'></span>
            <span v-html='linha.numero'></span>
            <span v-html='" ( " + linha.complemento + ")"'></span>
          </template>

          <!-- REPRESENTANTE LEGAL -->
          <template v-slot:col_habilitada="{ linha, indexL }">
            <div :data-time="time" :key="'hab_' + linha.habilitada + '--' + campos.icone.time">
              <App-Button :data-time="time" v-if="[ '', null, undefined ].indexOf(campos.icone.habilitada['_' + indexL]) !== -1"
              :cpntStatus="liberado"
              :cpntIcone="linha._habilitada.icone"
              @onClick='() => { subaseGerHabilitadaEditar(linha, indexL) }'
              ></App-Button>

              <template v-else>
                <App-Select :data-time="time"
                  :cpntStatus='campos.icone.habilitada["_" + indexL].seletor.status'
                  :cpntId='campos.icone.habilitada["_" + indexL].seletor.id'
                  :cpntTabIndex='campos.icone.habilitada["_" + indexL].seletor.tabIndex'
                  :cpntNome='campos.icone.habilitada["_" + indexL].seletor.nome'
                  :cpntValue='campos.icone.habilitada["_" + indexL].seletor.value'
                  :cpntMensagem='campos.icone.habilitada["_" + indexL].seletor.mensagem'
                  :cpntMensagemTipo='campos.icone.habilitada["_" + indexL].seletor.mensagemTipo'
                  :cpntDisabled='campos.icone.habilitada["_" + indexL].seletor.disabled'
                  :cpntMostrar='campos.icone.habilitada["_" + indexL].seletor.mostrar'
                  :cpntExplica='campos.icone.habilitada["_" + indexL].seletor.explica'
                  :cpntPlaceholder='campos.icone.habilitada["_" + indexL].seletor.placeholder'
                  :cpntValueRef='campos.icone.habilitada["_" + indexL].seletor.valueRef'
                  :cpntRouter='campos.icone.habilitada["_" + indexL].seletor.router'
                  :cpntMethod='campos.icone.habilitada["_" + indexL].seletor.method'
                  :cpntField='campos.icone.habilitada["_" + indexL].seletor.field'
                  :cpntWhere='campos.icone.habilitada["_" + indexL].seletor.where'
                  :cpntAddButForm='campos.icone.habilitada["_" + indexL].seletor.addButForm'
                  :cpntKeyMostra='campos.icone.habilitada["_" + indexL].seletor.keyMostra'
                  :cpntTipoOrder='campos.icone.habilitada["_" + indexL].seletor.tipoOrder'
                  :cpntOrder='campos.icone.habilitada["_" + indexL].seletor.order'
                  :cpntOptions='campos.icone.habilitada["_" + indexL].seletor.options'
                  :cpntKeyValue='campos.icone.habilitada["_" + indexL].seletor.keyValue'
                  :cpntSearchMinimo='campos.icone.habilitada["_" + indexL].seletor.searchMinimo'
                  :cpntMask='campos.icone.habilitada["_" + indexL].seletor.mask'
                  :cpntOptionInicialNome='campos.icone.habilitada["_" + indexL].seletor.optionInicialNome'
                  :cpntOptionInicialValue='campos.icone.habilitada["_" + indexL].seletor.optionInicialValue'

                  :cpntOnChange='(value) => { subaseGerHabilitadaOnChange(value, "_" + indexL, "seletor") }'
                  :ref='"_" + indexL + "_seletor"'
                ></App-Select>

                <template v-if='campos.icone.habilitada["_" + indexL].seletor.value === "0" || campos.icone.habilitada["_" + indexL].seletor.value.id === "0"'>
                  <App-Calendario :data-time="time"
                    :cpntStatus='campos.icone.habilitada["_" + indexL].input.status'
                    :cpntId='campos.icone.habilitada["_" + indexL].input.id'
                    :cpntClassDivField='campos.icone.habilitada["_" + indexL].input.classDivField'
                    :cpntNome='campos.icone.habilitada["_" + indexL].input.nome'
                    :cpntValue='campos.icone.habilitada["_" + indexL].input.value'
                    :cpntAutoComplete='campos.icone.habilitada["_" + indexL].input.autocomplete'
                    :cpntMask='campos.icone.habilitada["_" + indexL].input.mask'
                    :cpntDisabled='campos.icone.habilitada["_" + indexL].input.disabled'
                    :cpntMostrar='campos.icone.habilitada["_" + indexL].input.mostrar'
                    :cpntAutoFocus='campos.icone.habilitada["_" + indexL].input.autofocus'
                    :cpntMensagem='campos.icone.habilitada["_" + indexL].input.mensagem'
                    :cpntMensagemTipo='campos.icone.habilitada["_" + indexL].input.mensagemTipo'
                    :cpntPlaceholder='campos.icone.habilitada["_" + indexL].input.placeholder'
                    :cpntExplica='campos.icone.habilitada["_" + indexL].input.explica'
                    :cpntConfig='campos.icone.habilitada["_" + indexL].input.config'
                    :cpntPosicionar='campos.icone.habilitada["_" + indexL].input.posicionar'
                    :cpntTabIndex='campos.icone.habilitada["_" + indexL].input.tabIndex'

                    :cpntOnChange='(value) => { subaseGerHabilitadaOnChange(value, "_" + indexL, "input") }'
                    :ref='"_" + indexL + "_input"'
                  ></App-Calendario>

                  <span v-html="subaseGerBloqueadaFrase('_' + indexL)"></span>
                </template>

                <App-Button :data-time="time" v-if="per_atendimento === true"
                :cpntStatus="campos.icone.habilitada['_' + indexL].salvar.status"
                :cpntTexto="campos.icone.habilitada['_' + indexL].salvar.texto"
                :cpntClass="campos.icone.habilitada['_' + indexL].salvar.class"
                @onClick="() => { subaseGerHabilitadaSalvar('_' + indexL, linha.clu) }"
                ></App-Button>
              </template>
            </div>
          </template>

          <!-- REPRESENTANTE LEGAL -->
          <template v-slot:col_certificado="{ linha }">
            <template v-if="[ '', null, undefined ].indexOf(linha.certificado) !== -1">
              ---
            </template>
            <App-Button v-else :key="'cer_' + linha.certificado_diff"
            :cpntStatus="liberado"
            :cpntIcone="linha._certificado.icone"
            @onClick='() => { subaseGerTabDetalhesCLU(linha.clu, "certificado") }'
            ></App-Button>
          </template>

          <template v-slot:col_ultimo_acesso="{ linha }">
            <span v-html="linha._ultimo_acesso"></span>
          </template>

          <template v-slot:col_bd="{ linha }">
            <App-Button v-if="[ '', null, undefined ].indexOf(linha.bd_internet) === -1"
            :cpntStatus="liberado"
            :cpntIcone="'bd'"
            :cpntExplica="{ mensagem: 'Banco de dados (' + linha.bd_internet + ') na versão (' + linha.bd_versao_id + ').', posicaoMy: 'top right', posicaoAt: 'bottom left' }"
            @onClick='() => { subaseGerCopiarNomeBD(linha.bd_internet) }'
            ></App-Button>
            <template v-else>
              ---
            </template>
          </template>

          <template v-slot:col_pacotes="{ linha }">
            <App-Button v-if="[ '', null, undefined ].indexOf(linha.bd_internet) === -1"
            :cpntStatus="liberado"
            :cpntIcone="'pacotes'"
            :cpntExplica="{ mensagem: 'Clique aqui para verificar os pacotes do Licença de Uso.', posicaoMy: 'top right', posicaoAt: 'bottom left' }"
            @onClick='() => { subaseGerTabDetalhesCLU(linha.clu, "pacotes") }'
            ></App-Button>
            <template v-else>
              ---
            </template>
          </template>

          <template v-slot:col_pagamentos="{ linha }">
            <App-Button v-if="[ '', null, undefined ].indexOf(linha.bd_internet) === -1 && [ '', null, undefined ].indexOf(linha.con_lic_data) === -1"
            :cpntStatus="liberado"
            :cpntIcone="'financeiro_pdv'"
            :cpntExplica="{ mensagem: 'Clique aqui para verificar os pagamentos do Licença de Uso.', posicaoMy: 'top right', posicaoAt: 'bottom left' }"
            @onClick='() => { subaseGerTabDetalhesCLU(linha.clu, "pagamento") }'
            ></App-Button>
            <template v-else>
              ---
            </template>
          </template>

          <template v-slot:col_acao="{ linha }">
            <App-Button :data-time="time" v-if="per_gerenciar === true"
            :cpntStatus="liberado"
            :cpntTexto="campos.gerenciar.texto"
            @onClick='() => { campos.gerenciar.onClick(linha.clu) }'
            ></App-Button>

            <App-Button :data-time="time" v-if="per_atendimento === true"
            :cpntStatus="liberado"
            :cpntTexto="campos.atendimento.texto"
            @onClick='() => { campos.atendimento.onClick(linha) }'
            ></App-Button>
          </template>

          <template v-slot:editar_celula="vetor">
            <!-- CHAMA A FUNÇÃO PARA CARREGAR OS DADOS -->
            <template v-if="campoEditar.tipo === '' || (campoEditar.hash !== vetor.hash)">
              <!-- EXECUTA A FUNÇÃO PARA MONTAR O CAMPO -->
              {{ subaseGerTabIniciarEdicaoCampo(vetor) }}

              <!-- SETA O STATUS DO CAMPO -->
              <App-Status-2 :cpntStatus='"carregando"' ></App-Status-2>
            </template>

            <!-- SETA O CAMPO INPUT -->
            <App-Input :data-time="time" v-else-if='campoEditar.tipo === "input"'
              :cpntStatus='campoEditar.status'
              :cpntId='campoEditar.id'
              :cpntTabIndex='campoEditar.tabIndex'
              :cpntNome='campoEditar.nome'
              :cpntValue='campoEditar.value'
              :cpntMensagem='campoEditar.mensagem'
              :cpntDisabled='campoEditar.disabled'
              :cpntMostrar='campoEditar.mostrar'
              :cpntExplica='campoEditar.explica'
              :cpntPlaceholder='campoEditar.placeholder'
              :cpntValueRef='campoEditar.valueRef'
              :cpntRouter='campoEditar.router'
              :cpntMethod='campoEditar.method'
              :cpntField='campoEditar.field'
              :cpntWhere='campoEditar.where'
              :cpntAddButForm='campoEditar.addButForm'
              :cpntKeyMostra='campoEditar.keyMostra'
              :cpntTipoOrder='campoEditar.tipoOrder'
              :cpntOrder='campoEditar.order'
              :cpntOptions='campoEditar.options'
              :cpntKeyValue='campoEditar.keyValue'
              :cpntSearchMinimo='campoEditar.searchMinimo'
              :cpntMask='campoEditar.mask'

              :cpntOnChange='campoEditar.onChange'
              :cpntOnBlur='campoEditar.onBlur'
              :cpntOnRealizaBusca='campoEditar.onRealizaBusca'
              :cpntOnKeyPressEnter='vetor.salvar'
              :ref="campoEditar.id"
            ></App-Input>
          </template>
        </App-Tabela>
      </div>
    </template>
  </div>
</template>

<style scoped>
</style>

<style>
/* ==================================> COLUNAS */
.subase-ger > .tabela > table > tbody > tr > td.col_bd,
.subase-ger > .tabela > table > tbody > tr > td.col_pacotes,
.subase-ger > .tabela > table > tbody > tr > td.col_pagamentos,
.subase-ger > .tabela > table > tbody > tr > td.col_certificado {
  width: 70px !important;
  min-width: 70px !important;
  max-width: 70px !important;
}

/* ==================================> LOGO */
.subase-ger > .tabela > table > tbody > tr > td.col_logo {
  width: 110px;
}
  .subase-ger > .tabela > table > tbody > tr > td.col_logo > div > span > img {
    max-width: 100px;
    max-height: 45px;
  }

/* ==================================> CLU */
.subase-ger > .tabela > table > tbody > tr > td.col_ultimo_acesso > div > span > span > .vermelho {
  color: red;
}

/* ==================================> CLU */
.subase-ger > .tabela > table > tbody > tr > td.col_clu {
  width: 80px;
}

/* ==================================> AMBIENTE DO EMISSOR */
.subase-ger > .tabela > table > tbody > tr > td.col_ambiente {
  width: 182px !important;
  min-width: 182px !important;
  max-width: 182px !important;
  text-align: left;
}
  .subase-ger > .tabela > table > tbody > tr > td.col_ambiente > div > span > div {
    margin: 5px 0px;
  }
    .subase-ger > .tabela > table > tbody > tr > td.col_ambiente > div > span > div > div {
      display: inline-block;
    }
    .subase-ger > .tabela > table > tbody > tr > td.col_ambiente > div > span > div > .modelo {
      width: 37px;
      margin-right: 3px;
      text-align: right;
    }
    .subase-ger > .tabela > table > tbody > tr > td.col_ambiente > div > span > div > .ambiente {
      width: 72px;
      margin-right: 3px;
    }
    .subase-ger > .tabela > table > tbody > tr > td.col_ambiente > div > span > div > .emissor {
      font-size: calc(100% - 3px);
      font-style: italic;
    }


/* ==================================> HABILITADA */
.subase-ger > .tabela > table > tbody > tr > td.col_habilitada {
  width: 90px !important;
  min-width: 90px !important;
  max-width: 90px !important;
}
  .subase-ger > .tabela > table > tbody > tr > td.col_habilitada > div > span > div > button:not(.salvar) {
    padding: 2px 4px;
  }
    .subase-ger > .tabela > table > tbody > tr > td.col_habilitada > div > span > div > button:not(.salvar) > span > svg {
      font-size: 20px;
    }
  .subase-ger > .tabela > table > tbody > tr > td.col_habilitada > div > span > div > .cpnt-app-campo:not(:first-child) {
    margin-top: 5px;
  }
  .subase-ger > .tabela > table > tbody > tr > td.col_habilitada > div > span > div > .salvar {
    margin-top: 5px;
    width: 100%;
  }

/* ==================================> BD */
.subase-ger > .tabela > table > tbody > tr > td.col_bd > div > span > button {
  padding: 2px 4px;
}
  .subase-ger > .tabela > table > tbody > tr > td.col_bd > div > span > button > span > svg {
    font-size: 20px;
    opacity: 0.70;
  }

/* ==================================> PACOTES */
.subase-ger > .tabela > table > tbody > tr > td.col_pacotes > div > span > button {
  padding: 3px 5px;
}
  .subase-ger > .tabela > table > tbody > tr > td.col_pacotes > div > span > button > span > svg {
    font-size: 18px;
    opacity: 0.70;
  }

/* ==================================> PAGAMENTOS */
.subase-ger > .tabela > table > tbody > tr > td.col_pagamentos > div > span > button {
  padding: 2px 4px;
}
  .subase-ger > .tabela > table > tbody > tr > td.col_pagamentos > div > span > button > span > svg {
    font-size: 20px;
    opacity: 0.70;
  }

/* ==================================> CERTIFICADO */
.subase-ger > .tabela > table > tbody > tr > td.col_certificado > div > span > button {
  padding: 2px 4px;
}
  .subase-ger > .tabela > table > tbody > tr > td.col_certificado > div > span > button > span > svg {
    font-size: 20px;
  }

/* ==================================> AÇÕES */
.subase-ger > .tabela > table > tbody > tr > td.col_acao {
  max-width: 165px;
}
  .subase-ger > .tabela > table > tbody > tr > td.col_acao > div > span > button {
    min-width: 135px;
    margin: 3px;
  }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    props: {
      cpntContatoId: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntClu: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntLicencaTipo: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntRemoverCampos: {
        required: false,
        default: function () {
          return [ ]
        }
      }
    },
    components: {
      'App-Status-2': () => import('@/components/rf-geral/status/RF-Status-2.vue'),
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'App-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue'),
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        liberado: 'carregando',
        checkbox: [],
        tabper: 'CliRotinaFacil',
        route: '/subase/cli-rotinafacil/get',
        colunas: [],
        linha: [],
        tabPerOrder: [
          { id: '0', nome: 'CLU Decrescente',  chave: 'clu',          order: 'desc' },
          { id: '1', nome: 'CLU Crescente',    chave: 'clu',          order: 'asc' },
          { id: '2', nome: 'Ordem Alfabética', chave: 'cliente',      order: 'asc' }
        ],  
        where: {},
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        campos: {
          gerenciar: {
            id: 'sub-ger-bt-ger--',
            tipo: 'texto',
            texto: 'Gerenciar',
            status: '',
            disabled: false,
            class: 'btn btn-sm btn-default',
            acao: 'gerenciar',
            onClick: this.subaseGerGerenciarCLU
          },
          atendimento: {
            id: 'sub-ger-bt-atendimento--',
            tipo: 'texto',
            texto: 'Iniciar Atendimento',
            status: '',
            disabled: false,
            class: 'btn btn-sm btn-default',
            acao: 'atendimento',
            onClick: this.subaseGerIniciarAtendimento
          },
          icone: {
            id: 'sub-ger-bt-',
            tipo: 'icone',
            status: '',
            disabled: false,
            mostrar: true,
            explica: null,
            class: 'btn btn-default btn-sm',
            time: '',
            habilitada: {}
          }
        },
        per_gerenciar: this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, [ 18 ], null, [ 35 ], null, false) === true,
        per_atendimento: this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 29 ], null, [ 53 ], null, [ 569 ], null, false) === true
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.subaseGerTabSetarStatusGeral('carregando')
      
      // INICIA O CARREGAMENTO DA TELA
      this.subaseGerTabBuscarLinhas()
    },
    destroyed: function () {
      $('.qtip-cpnt-tab-subase-ger').qtip('destroy')
    },
    methods: {
      subaseGerTabFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.subaseGerTabBuscarLinhas()
        }
      },
      subaseGerTabBuscarLinhas: function () {
        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 1,    chave: 'logo',                    nome: 'Logotipo',                 fieldsApi: { cod_img: null, v_img: null }                                   },
          { mPer: 2,    chave: 'clu',                     nome: 'CLU',                      fieldsApi: { clu: null, bd_internet: null }                                 },
          { mPer: 2,    chave: 'nome',                    nome: 'Cliente (CNPJ)',           fieldsApi: { cliente: null, cnpj: null }                                    },
          { mPer: 1,    chave: 'representante',           nome: 'Representante (CPF)',      fieldsApi: { rep_leg: null, rep_cpf: null }                                 },
          { mPer: 1,    chave: 'email',                   nome: 'E-mail',                   fieldsApi: { email: null }                                                  },
          { mPer: 0,    chave: 'site',                    nome: 'Site',                     fieldsApi: { site: null }                                                   },
          { mPer: 1,    chave: 'rt_id',                   nome: 'Regime tributário',        fieldsApi: { rt_id: null, rt_3_opt: null }                                  },
          { mPer: 0,    chave: 'cep',                     nome: 'CEP',                      fieldsApi: { cep: null }                                                    },
          { mPer: 0,    chave: 'endereco',                nome: 'Endereço',                 fieldsApi: { endereco: null, numero: null, complemento: null }              },
          { mPer: 0,    chave: 'bairro',                  nome: 'Bairro',                   fieldsApi: { bairro: null }                                                 },
          { mPer: 0,    chave: 'id_cidade_cidade',        nome: 'Cidade',                   fieldsApi: { id_cidade: { j: { cidade: null } } }      },
          { mPer: 0,    chave: 'id_estado_estado',        nome: 'Estado',                   fieldsApi: { id_estado: { j: { estado: null } } }      },
          { mPer: 1,    chave: 'data_ini_sis',            nome: 'Data Cadastro',            fieldsApi: { data_ini_sis: null }                                           },
          { mPer: 1,    chave: 'habilitada',              nome: 'Habilitada',               fieldsApi: { habilitada: null, data_blok: null }                            },
          { mPer: 1,    chave: 'contrato',                nome: 'Contrato',                 fieldsApi: { con_dem_data: null, n_dias_teste: null, con_lic_data: null }, fieldsVir: [ 'contador_free' ]   },
          { mPer: 0,    chave: 'bd',                      nome: 'BD',                       fieldsApi: { bd_versao_id: null }                                           },
          { mPer: 1,    chave: 'pacotes',                 nome: 'Pacotes'                                                                                               },
          { mPer: 1,    chave: 'pagamentos',              nome: 'Pagamento'                                                                                            },
          { mPer: 1,    chave: 'certificado',             nome: 'Certificado',              fieldsApi: { id_con_subase: null, cda1_val: null }                                               },
          { mPer: 1,    chave: 'ambiente',                nome: 'DF-e Ambiente',            fieldsApi: { NFe_emissor: null, NFe_tpAmb: null, NFCe_emissor: null, NFCe_tpAmb: null, NFSe_emissor: null, NFSe_tpAmb: null } },
          { mPer: 1,    chave: 'ultimo_acesso',           nome: 'Último Acesso',            fieldsVir: [ 'ult_ace_cliente' ]                                               },
          { mPer: 3,    chave: 'acao',                    nome: 'Ações'                                                                                                  }
        ]

        // VERIFICA SE DEVE REMOVER OS CAMPOS
        if (this.cpntRemoverCampos.length >= 1) {
          // SETA AS COLUNAS QUE DEVE MANTER
          if (this.cpntRemoverCampos.indexOf('cartao_contato') !== -1) {
            colunas = colunas.filter(item => [ 'clu', 'nome', 'habilitada', 'contrato', 'pacotes', 'pagamentos', 'certificado', 'ultimo_acesso', 'acao' ].indexOf(item.chave) !== -1)
          }

          // REMOVE AS OUTRAS COLUNAS SOLICITADAS
          colunas = colunas.filter(item => this.cpntRemoverCampos.indexOf(item.chave) === -1)

          // REMOVE A PAGINAÇÃO DA TELA, SE NÃO TIVER MINHA PERSONALIZAÇÃO
          if (this.cpntRemoverCampos.indexOf('mper') !== -1) {
            this.estruturaQueryGet[0].push('SemPaginacao')
          }
        }

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [] }

        // SETA O ID DO CONTATO QUE DEVE BUSCAR
        if ([ '', null, undefined ].indexOf(this.cpntContatoId) === -1) {
          this.where.aAnd.push({ f: 'id_con_subase', o: '=', v: this.cpntContatoId })
        }

        // SETA O ID DO CONTATO QUE DEVE BUSCAR
        if ([ '', null, undefined ].indexOf(this.cpntLicencaTipo) === -1) {
          switch (this.cpntLicencaTipo) {
            case 'contador':
              this.where = { aAnd: [ {
                m: 'cliente_rotinafacil',
                f: 'clu',
                r: 'clu_dependente',
                q: {
                  model: 'clu_dependente',
                  where: { aAnd: [ { f: 'clu_principal', o: '=', v: this.cpntClu }, { f: 'status', o: '=', v: '1' } ] }
                }
              } ] }
              break

            case 'cliente':
              this.where = { aAnd: [ {
                m: 'cliente_rotinafacil',
                f: 'clu',
                r: 'clu_principal',
                q: {
                  model: 'clu_dependente',
                  where: { aAnd: [ { f: 'clu_dependente', o: '=', v: this.cpntClu }, { f: 'status', o: '=', v: '1' } ] }
                }
              } ] }
              break
          }
          
          // SETA QUE DEVE BUSCAR TODOS OS REGISTROS DO CONTADOR
          this.estruturaQueryGet[0].push('SemPaginacao')
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // LIMPA OS CAMPOS QUE ESTÃO SENDO EDITADOS
        this.campos.icone.habilitada = {}

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
          this.subaseGerTabReiniciar()
        } else {
          this.subaseGerTabSetarStatusGeral('')
        }
      },
      subaseGerTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}
        
        // CONVERTE O VALOR RECEBIDO
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'nome':
            retorno.where = { aOr: [
              { f: 'cliente', o: where.o, v: where.v },
              { f: 'rep_leg', o: where.o, v: where.v }
            ] }
            break

          case 'cpf':
            retorno.where = { f: 'rep_cpf', o: where.o, v: where.v }
            break

          case 'email':
            retorno.where = { f: 'email', o: where.o, v: where.v }
            break

          case 'cidade':
            retorno.where = { f: 'id_cidade', o: where.o, v: where.v }
            break

          case 'estado':
            retorno.where = { f: 'id_estado', o: where.o, v: where.v }
            break

          case 'busca':
            retorno.where = { aOr: [ { o: 's.ft', v: where.v } ] }
            break

          case 'regime':
            retorno.where = { f: 'rt_id', o: where.o, v: where.v }
            break

          case 'contador':
            retorno.where = {
              m: 'cliente_rotinafacil',
              f: 'clu',
              r: 'clu_principal',
              o: (where.v === 's' ? 'in' : 'notIn'),
              q: {
                model: 'clu_dependente',
                field: { clu_principal: null },
                where: { aAnd: [
                  { f: 'id_pac', o: '=', v: '34' },
                  { f: 'status', o: '=', v: '1' }
                ] }
              }
            }
            break

          case 'certificado':
            // VERIFICA SE TEM QUE GERAR O VALOR
            if ([ '', null, undefined ].indexOf(where.v._dataIni) !== -1) {
              where.v._dataIni = moment(where.v.dataIni, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            if ([ '', null, undefined ].indexOf(where.v._dataFim) !== -1) {
              where.v._dataFim = moment(where.v.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }

            // SETA O WHERE QUE DEVE REALIZAR
            if (where.o === '=') {
              retorno.where = { aAnd: [
                { f: 'cda1_val', o: '>=', v: where.v._dataIni + ' 00:00:00' },
                { f: 'cda1_val', o: '<=', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if (where.o === '<>') {
              retorno.where = { aOr: [
                { f: 'cda1_val', o: '<', v: where.v._dataIni + ' 00:00:00' },
                { f: 'cda1_val', o: '>', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '<=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { f: 'cda1_val', o: where.o, v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '>=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { f: 'cda1_val', o: '>', v: where.v._dataIni + ' 00:00:00' }
              ] }
            }
            break

          case 'contrato_dem':
          case 'contrato_lic':
            switch (where.f + '__' + where.o) {
              case 'contrato_dem__aceito':
                retorno.where = (where.v === 's' ? { aAnd: [ { f: 'con_dem_data', o: 'isNotNull' }, { f: 'con_lic_data', o: 'isNull' } ] } : { f: 'con_dem_data', o: 'isNull' })
                break

              case 'contrato_lic__aceito':
                retorno.where = (where.v === 's' ? { f: 'con_lic_data', o: 'isNotNull' } : { f: 'con_lic_data', o: 'isNull' })
                break
            }
            break

          case 'removido':
            retorno.where = (where.v === 's' ? { f: 'auto_removido', o: '=', v: '1' } : { f: 'auto_removido', o: '=', v: '0' })
            break

          case 'habilitada':
            switch (where.v) {
              case 'h':
                retorno.where = { f: 'habilitada', o: where.o, v: '1' }
                break

              case 'b':
                retorno.where = { f: 'habilitada', o: where.o, v: '0' }
                break

              case 'c':
                retorno.where = { f: 'habilitada', o: where.o, v: '2' }
                break
            }
            break

          case 'NFe':
          case 'NFCe':
          case 'NFSe':
            switch (where.o) {
              case 'emissor':
                retorno.where = { f: where.f + '_emissor', o: '=', v: where.v }
                break

              case 'ambiente':
                retorno.where = { f: where.f + '_tpAmb', o: '=', v: where.v }
                break
            }
            break

          case 'clu':
            switch (where.o) {
              case '=':
                retorno.where = { f: where.f, o: 'in', v: where.v }
                break

              case '<>':
                retorno.where = { f: where.f, o: 'notIn', v: where.v }
                break
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      subaseGerTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subaseGerTabSetarStatusLiberado: function (status) {
        // SETA O STATUS DA TELA
        this.liberado = (status === '' || status === true) ? '' : (status === false ? 'carregando' : status)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subaseGerTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.subaseGerTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      subaseGerTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            if ([ '', null, undefined ].indexOf(this.cpntContatoId) !== -1 && [ '', null, undefined ].indexOf(this.cpntLicencaTipo) !== -1) {
              this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
            } else {
              callback()
            }
          } else {
            setTimeout(() => { this.subaseGerTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      subaseGerTabMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar((vetor) => {
              // REMOVE O VALOR DO CAMPO
              this.where.aAnd = this.where.aAnd.filter(item => item.f !== 'auto_removido')

              // VERIFICA SE TEM FILTRO REMOVIDO
              if (vetor.filter(item => item.f === 'removido').length === 0) {
                this.where.aAnd.push({ f: 'auto_removido', o: '=', v: '0' })
              }

              // RETORNA OS VALORES RECEBIDOS
              callback(vetor)
            })
          } else {
            setTimeout(() => { this.subaseGerTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      subaseGerTabSetarLinhas: function (vetor) {
        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          // INICIA O VETOR DA LOGOTIPO
          vetor[index].logo = process.env.VUE_APP_S3_URI + process.env.VUE_APP_BUCKET_RF + '/img_cli/nao_encontrada.png'

          // VERIFICA SE TEM LOGOTIPO INSERIDA
          if ([ '', null, undefined ].indexOf(vetor[index].cod_img) === -1 && [ '', null, undefined, '0' ].indexOf(vetor[index].v_img) === -1) {
            vetor[index].logo = process.env.VUE_APP_S3_URI + process.env.VUE_APP_BUCKET_RF + '/img_cli/' + vetor[index].cod_img + '.png?v=' + vetor[index].v_img
          }

          // INICIA A VARIAVEL DO CERTIFICADO
          vetor[index].certificado = ''
          vetor[index].certificado_diff = ''

          // VERIFICA SE TEM CERTIFICADO DIGITAL
          if ([ '', null, undefined ].indexOf(vetor[index].cda1_val) === -1) {
            // CONVERTE A DATA DO BLOQUEIO
            var certificado = moment(vetor[index].cda1_val, 'YYYY-MM-DD HH:mm:ss')
  
            // CALCULA A DIFERENÇA DAS DATAS
            vetor[index].certificado_diff = certificado.diff(moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss'), 'days')
  
            // SETA A DATA FORMATADA DO CERTIFICADO
            vetor[index].certificado = certificado.format('DD/MM/YYYY HH:mm:ss')
          }

          // INICIA A VARIAVEL DO BLOQUEIO
          vetor[index].data_blok_diff = ''

          // SETA AS INFORMAÇÕES DE CADA ICONE
          if (vetor[index].habilitada === '0') {
            // CONVERTE A DATA DO BLOQUEIO
            var bloqueio = moment(vetor[index].data_blok.split(' ')[0], 'YYYY-MM-DD')

            // CALCULA A DIFERENÇA DAS DATAS
            vetor[index].data_blok_diff = bloqueio.diff(moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY'), 'days')

            // SETA A DATA E HORA ATUALIZADA
            vetor[index].data_blok = bloqueio.format('DD/MM/YYYY')
          }

          // FORMATA O VALOR RECEBIDO
          vetor[index]._email = ''
          if ([ '', null, undefined ].indexOf(vetor[index].email) === -1) {
            vetor[index]._email = vetor[index].email.split(";").join("<br/>")
          }

          // FORMATA O VALOR RECEBIDO
          vetor[index]._cep = ''
          if ([ '', null, undefined ].indexOf(vetor[index].cep) === -1) {
            vetor[index]._cep = this.subaseGerTabFormatarCep(vetor[index].cep)
          }

          // INICIA O VALOR DO CAMPO
          vetor[index]._ambiente = ''
          if ([ '', null, undefined ].indexOf(vetor[index].NFe_tpAmb) === -1 || [ '', null, undefined ].indexOf(vetor[index].NFCe_tpAmb) === -1 || [ '', null, undefined ].indexOf(vetor[index].NFSe_tpAmb) === -1) {
            vetor[index]._ambiente = [
              { modelo: 'NF-e',   ambiente: this.subaseGerTabNomeAmbiente(vetor[index].NFe_tpAmb),   emissor: this.subaseGerTabNomeEmissor(vetor[index].NFe_emissor)  },
              { modelo: 'NFC-e',  ambiente: this.subaseGerTabNomeAmbiente(vetor[index].NFCe_tpAmb),  emissor: this.subaseGerTabNomeEmissor(vetor[index].NFCe_emissor) },
              { modelo: 'NFS-e',  ambiente: this.subaseGerTabNomeAmbiente(vetor[index].NFSe_tpAmb),  emissor: this.subaseGerTabNomeEmissor(vetor[index].NFSe_emissor) }
            ]
          }

          // FORMATA AS DATAS RECEBIDAS
          vetor[index]._con_dem_data = this.subaseGerTabFormatarData(vetor[index].con_dem_data) + '. ' + this.subaseGerTabMontarFraseDemonstrativo(vetor[index])
          vetor[index]._con_lic_data = this.subaseGerTabFormatarData(vetor[index].con_lic_data)
          vetor[index]._data_ini_sis = this.subaseGerTabFormatarData(vetor[index].data_ini_sis)

          // SETA OS DADOS DO ULTIMO ACESSO
          vetor[index]._ultimo_acesso = '---'
          if ([ '', null, undefined ].indexOf(vetor[index].virtual_ult_ace_cliente) === -1) {
            vetor[index]._ultimo_acesso = this.subaseGerTabUltimoAcesso(vetor[index].virtual_ult_ace_cliente)
          }

          // INICIA A VARIAVEL
          vetor[index]._habilitada = { icone: 'check-verde', explica: null }

          // VERIFICA O VALOR QUE DEVE PREENCHER
          if ([ '', null, undefined ].indexOf(vetor[index].habilitada) === -1 && vetor[index].habilitada !== '1') {
            if (vetor[index].habilitada === '0') {
              if (vetor[index].data_blok_diff <= -90) {
                vetor[index]._habilitada = { icone: 'alerta-vermelho', explica: { mensagem: "<b>Cancelado</b>, através de bloqueio desde o dia " + vetor[index].data_blok, posicaoMy: "top right", posicaoAt: "bottom left" } }
              } else if (vetor[index].data_blok_diff <= 0) {
                vetor[index]._habilitada = { icone: 'alerta-vermelho', explica: { mensagem: "Bloqueado desde o dia " + vetor[index].data_blok, posicaoMy: "top right", posicaoAt: "bottom left" } }
              } else {
                vetor[index]._habilitada = { icone: 'alerta-amarelo', class: 'rf-icon-amarelo', explica: { mensagem: "Bloquear a partir do dia " + vetor[index].data_blok + ", o cliente ainda tem " + vetor[index].data_blok_diff + " para utilizar.", posicaoMy: "top right", posicaoAt: "bottom left" } }
              }
            } else if (vetor[index].habilitada === '2') {
              vetor[index]._habilitada = { icone: 'erro-vermelho', explica: { mensagem: "Licença de uso <b>Cancelada</b>", posicaoMy: "top right", posicaoAt: "bottom left" } }
            }
          }

          // INICIA A VARIAVEL
          vetor[index]._certificado = { icone: 'check-verde', explica: null }

          // VERIFICA SE TEM CERTIFICADO DIGITAL
          if ([ '', null, undefined ].indexOf(vetor[index].certificado_diff) === -1) {
            if (vetor[index].certificado_diff <= 0) {
              vetor[index]._certificado = { icone: 'erro-vermelho', class: 'rf-icon-vermelho', explica: { mensagem: "VENCIDO há " + (vetor[index].certificado_diff * (-1)) + " dia(s).", posicaoMy: "top right", posicaoAt: "bottom left" } }
            } else if (vetor[index].certificado_diff <= 30) {
              vetor[index]._certificado = { icone: 'alerta-amarelo', class: 'rf-icon-amarelo', explica: { mensagem: "Certificado vence em " + vetor[index].certificado + " totalizando " + vetor[index].certificado_diff + " dias.<br/>", posicaoMy: "top right", posicaoAt: "bottom left" } }
            }
          }
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subaseGerTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { id: 'clu',          nome: 'CLU' },
          { slot: 'contato',    remover: [ 'id_tp_con_nome', 'telefone', 'pessoa', 'tp_con' ] },
          { id: 'habilitada',   nome: 'Status Habilitada' },
          { id: 'contrato_dem', nome: 'Contrato Demonstrativo' },
          { id: 'contrato_lic', nome: 'Contrato de Licença' },
          { id: 'certificado',  nome: 'Validade certificado' },
          { id: 'regime',       nome: 'Regime de Tributação' },
          { id: 'contador',     nome: 'Licença de uso contador' },
          { id: 'removido',     nome: 'Apenas CLU removidas' },
          { id: 'NFe',          nome: 'NF-e' },
          { id: 'NFCe',         nome: 'NFC-e' },
          { id: 'NFSe',         nome: 'NFS-e' },
        ]

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      subaseGerTabOnBuscarOptionsFiltroO: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'clu':
          case 'contador':
          case 'habilitada':
          case 'regime':
            vetor.options = [
              { id: '=',    nome: '= Igual',      _formatar: [ 'id' ] },
              { id: '<>',    nome: '<> Diferente', _formatar: [ 'id' ] }
            ]
            break

          case 'removido':
            vetor.options = [
              { id: '=',    nome: '= Igual',      _formatar: [ 'id' ] }
            ]
            break

          case 'contrato_dem':
          case 'contrato_lic':
            vetor.options = [
              { id: 'aceito', nome: 'Aceito' }
            ]
            break

          case 'NFe':
          case 'NFCe':
          case 'NFSe':
            vetor.options = [
              { id: 'ambiente', nome: 'Ambiente' },
              { id: 'emissor', nome: 'Emissor' }
            ]
            break

          case 'certificado':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: '= Igual',                _formatar: [ 'id' ] },
              { id: '<>',   nome: '<> Diferente',     _formatar: [ 'id' ] },
              { id: '>=',   nome: '>= Maior Igual',   _formatar: [ 'id' ] },
              { id: '<=',   nome: '<= Menor Igual',   _formatar: [ 'id' ] }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '<='
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      subaseGerTabOnBuscarOptionsFiltroV: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = { disabled: false }

        // INICIA A FUNÇÃO PARA FINALIZAR
        var finalizar = null

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'clu':
            vetor = Object.assign(vetor, {
              tipo: 'input',
              value: ''
            })
            break
          
          case 'removido':
          case 'contador':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: '',
              options: [
                { id: 's', nome: 'Sim'},
                { id: 'n', nome: 'Não'}
              ]
            })
            break

          case 'regime':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: 's',
              options: [
                { id: '1', nome: 'Simples Nacional' },
                { id: '2', nome: 'Simples Nacional – excesso de sublimite de receita bruta' },
                { id: '3', nome: 'Regime Normal' }
              ]
            })
            break

          case 'contrato_dem':
          case 'contrato_lic':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: 's',
              options: [
                { id: 's', nome: 'Sim'},
                { id: 'n', nome: 'Não'}
              ]
            })
            break

          case 'habilitada':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: 'h',
              options: [
                { id: 'h', nome: 'Habilitada'},
                { id: 'b', nome: 'Bloqueada'},
                { id: 'c', nome: 'Cancelada'}
              ]
            })
            break

          case 'certificado':
            vetor = Object.assign(vetor, {
              tipo: 'seletor-data',
              value: '30'
            })
            break

          case 'NFe':
          case 'NFCe':
          case 'NFSe':
            switch (valor.o) {
              case 'ambiente':
                vetor = Object.assign(vetor, {
                  tipo: 'select',
                  value: 's',
                  options: [
                    { id: '1', nome: 'Produção'},
                    { id: '2', nome: 'Homologação'}
                  ]
                })
                break

              case 'emissor':
                vetor = Object.assign(vetor, {
                  tipo: 'select',
                  value: 's',
                  options: [
                    { id: 'rf', nome: 'Rotina Fácil'},
                    { id: 'mi', nome: 'Migrate'}
                  ]
                })
                break
            }
            break
        }
        
        // RETORNA O VALOR MONTADO
        if (finalizar === null && Object.keys(vetor).length >= 2) {
          callback(vetor)
        }
      },
      subaseGerTabFormatarCep: function (valor) {
        return valor.replace(/^(\d{2})(\d{3})(\d{3})/, '$1.$2-$3')
      },
      subaseGerTabConectarClu: function (clu) {
        this.$store.state.comunicaAPI('/contador/usu-cliente/get/' + clu, 'GET', null, (retorno) => {
          window.open(retorno.data, '_blank')
        }, this.subaseGerTabSetarStatusGeral)
      },
      subaseGerTabDetalhesCLU: function (clu, tipo) {
        // SETA OS PARAMETROS PARA INICIAR
        var params = { tipo: 'DETALHES_LU', pagina: tipo, clu: clu }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      subaseGerIniciarAtendimento: function (linha) {
        // SETA OS PARAMETROS PARA INICIAR
        var params = { tipo: 'REGISTRO_ATENDIMENTO_INICIAR', contatoId: linha.id_con_subase, clu: linha.clu }

        // SETA A FUNÇÃO CALLBACK
        params.callback = (atualizar) => {
          if (atualizar === true && this.cpntFecharFormulario !== null && typeof this.cpntFecharFormulario === 'function') {
            this.cpntFecharFormulario(true)
          }
        }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      subaseGerGerenciarCLU: function (clu) {
        // SETA OS PARAMETROS PARA INICIAR
        var params = { tipo: 'GERENCIAR_CLU', params: { clu: clu } }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      subaseGerTabIniciarEdicaoOnChangeValue: function (value) {
        // SETA O VALOR RECEBIDO
        this.campoEditar.value = value

        // REMOVE A MENSAGEM DE ERRO
        this.campoEditar.mensagem = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subaseGerTabIniciarEdicaoCampo: function (vetor) {
        // INICIA O VETOR
        var linha = JSON.parse(JSON.stringify(vetor.linha))

        // INICIA O VETOR
        var campo = {}

        // VERIFICA O CAMPO QUE DEVE ABRIR
        switch (vetor.indexCV) {
          case 'email_fiscal':
            campo = {
              id: 'subase-ger-editar--' + vetor.indexCV,
              hash: vetor.hash,
              tipo: 'input',
              value: linha[vetor.indexCV]
            }
            break
        }

        // SETA OS VALORES RECEBIDOS
        campo.extra = vetor

        // SETA O VALOR INICIAL DO CAMPO
        campo.valueIni = campo.value

        // SETA O VALOR RECEBIDO NO VETOR
        this.campoEditar = Object.assign(this.campoEditar, campo)

        // SETA O FOCUS NO CAMPO
        this.subaseGerTabIniciarEdicaoFocusCampo(campo.id)
      },
      subaseGerTabIniciarEdicaoFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false) {
          if (tentativa <= 5) {
            if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
              this.$refs[chave].cpntRealizarFocus()
            } else {
              setTimeout(() => { this.subaseGerTabIniciarEdicaoFocusCampo(chave, (tentativa + 1)) }, 100)
            }
          }
        }
      },
      subaseGerTabEditar: function () {
        if (this.campoEditar.value !== this.campoEditar.valueIni) {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // COPIA O VETOR
          var vetor = this.campoEditar.extra

          // INICIA O VETOR
          var formData = {}

          // SETA O ID DO REGISTRO QUE ESTÁ SENDO EDITADO
          formData.clu_dependente = this.linha[vetor.indexL].clu

          // SETA O VALOR QUE DEVE ATUALIZAR
          formData[vetor.indexCV] = this.campoEditar.tipo === 'select' ? this.campoEditar.value[this.campoEditar.keyValue] : this.campoEditar.value

          // CONVERTE O VALOR PARA STRING
          formData[vetor.indexCV] = formData[vetor.indexCV].toString()

          // CONVERTE O VALOR EM LOT
          formData = { lot: [ formData ] }


          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/contador', 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
                this.subaseGerTabBuscarLinhas()
                break

              default:
                // PEGA A MENSAGEM RETORNADA
                var mensagem = []

                // VERIFICA SE É UM VETOR NA MENSAGEM
                if (typeof retorno.message === 'object') {
                  for (var indexR in retorno.message) {
                    mensagem.push(indexR + ' - ' + (typeof retorno.message[indexR] === 'string' ? retorno.message[indexR] : retorno.message[indexR].join(' ')))
                  }
                } else {
                  mensagem.push(retorno.message)
                }

                // SETA OS DADOS RECEBIDOS NO CAMPO
                this.campoEditar.mensagem = mensagem.join('<br/>')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                break
            }
          }, this.subaseGerTabSetarStatusGeral)
        }
      },
      subaseGerTabFormatarData: function (valor, entrada = 'YYYY-MM-DD', saida = 'DD/MM/YYYY') {
        return moment(valor, entrada).format(saida)
      },
      subaseGerTabNomeAmbiente: function (valor) {
        switch (valor) {
          case '2':
            return 'Homologação'
          
          case '1':
            return 'Produção'

          default:
            return '<span class="emissor" style="color: red;">ERRO</span>'
        }
      },
      subaseGerTabNomeEmissor: function (valor) {
        // INICIA A VARIAVEL PARA RETORNO
        var retorno = '('

        // VERIFICA O VALOR QUE DEVE COLOCAR
        switch (valor) {
          case 'mi':
            retorno += 'Migrate'
            break
          
          case 'rf':
            retorno += 'Rotina Fácil'
            break

          default:
            retorno += '<span style="color: red;">ERRO</span>'
            break
        }

        // FECHA O PARENTESES
        retorno += ')'

        // RETORNA O VALOR MONTADO
        return retorno
      },
      subaseGerTabUltimoAcesso: function (vetor) {
        // INICIA A VARIAVEL PARA RETORNO
        var retorno = '---'

        // VERIFICA SE TEM VALOR RECEBIDO
        if ([ '', null, undefined ].indexOf(vetor) === -1) {
          // TRANSFORMA A DATA E MOMENT.JS
          vetor._updated_at_ptbr = moment(vetor.updated_at_ptbr, 'DD/MM/YYYY HH:mm:ss')

          // CALCULA A DIFERENÇA DAS DATAS
          vetor.diff = moment.duration(moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss').diff(vetor._updated_at_ptbr))

          // PEGA O NUMERO DE DIAS
          var days = parseInt(vetor.diff.asDays())

          // PEGA O NUMERO DE HORAS
          var hours = parseInt(vetor.diff.asHours())

          // CALCULA A QUANTIDADE DE HORAS
          hours = hours - days*24

          // PEGA O NUMERO DE MINUTOS
          var minutes = parseInt(vetor.diff.asMinutes())

          // CALCULA A QUANTIDADE DE MINUTOS
          minutes = minutes - (days*24*60 + hours*60)

          // LIMPA A VARIAVEL
          retorno  = ''
          retorno += '<span>'
          retorno += '<span class="usuario">' + vetor.usuario + ' (' + vetor.id_usu + ')' + '</span> em '
          retorno += '<span class="data">' + vetor.updated_at_ptbr.replace(' ', ' às ') + '</span>'
          retorno += '</span><br/>'
          if (days > 0 || hours > 0 || minutes > 0) {
            retorno += '<span class="' + (days >= 8 ? 'vermelho' : '') + ' diferenca">Hà '
            if (days > 366) {
              retorno += Math.trunc(days / 365) + ' ano' + (days >= 2 ? 's' : '')
            } else if (days > 0) {
              retorno += days + ' dia' + (days >= 2 ? 's' : '')
            } else if (hours > 0) {
              retorno += hours + ' hora' + (hours >= 2 ? 's' : '')
            } else if (minutes > 0) {
              retorno += minutes + ' minuto' + (minutes >= 2 ? 's' : '')
            } else if (minutes > 0) {
              retorno += 'menos de 1 minuto.'
            }
            retorno += '</span>'
          }
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      subaseGerTabMontarFraseDemonstrativo: function (linha) {
        // PEGA A DATA DO DEMONSTRATIVO
        var demonstrativo = moment(linha.con_dem_data.split(' ')[0], 'YYYY-MM-DD')

        // SOMA AS DATA ATUAL MAIS OS DIAS PARA TESTE PARA PEGAR O FIM DO CONTRATO DE TESTE
        var demonstrativoFim = demonstrativo.add(Number(linha.n_dias_teste), 'd')

        // CALCULA A DIFERENÇA DAS DATAS
        var diff = demonstrativoFim.diff(moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY'), 'days')

        // VERIFICA SE TEM ALGUMA DIA PARA TESTE
        switch (diff >= 0) {
          case true:
            return '<br/><span style="font-size: 11px;">(Cliente ainda tem ' + diff + ' dia(s) para experimentar).</span>'

          default:
            return '<br/><span style="font-size: 11px;">(Aguardando aceite da licença).</span>'
        }
      },
      subaseGerCopiarNomeBD: function (bd_internet) {
        this.$store.commit('FUN_COPIAR_VALOR', { valor: bd_internet, mensagem: 'WEB [200]: Nome da base de dados (' + bd_internet + ') copiada para área de transferência.' })
      },
      subaseGerHabilitadaEditar: function (linha, indexL) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, [ 18 ], null, [ 215 ], null, false) === true) {
          // INICIA A CHAVE QUE SERÁ UTLIZADA
          var chave = '_' + indexL
  
          // INICIA O VETOR DE DADOS
          var vetor = {
            seletor: {
              options: [
                { id: '1', nome: 'Sim' },
                { id: '0', nome: 'Bloquear' },
                { id: '2', nome: 'Cancelado' },
              ],
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              searchMinimo: 1000,
              value: linha.habilitada
            },
            input: {
              value: linha.data_blok
            },
            salvar: {
              status: '',
              tipo: 'texto',
              texto: 'Salvar',
              class: [ 'btn', 'btn-primary', 'btn-sm', 'salvar' ]
            }
          }
  
          // SETA OS DADOS RECEBIDOS
          this.campos.icone.habilitada[chave] = vetor
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // SETA O TIME ATUALIZADO
          this.campos.icone.time = new Date().getTime()
        } else {
          this.$store.state.msgWarn('WEB [403]: Não autorizado. [Per. 215].', 'warning')
        }
      },
      subaseGerHabilitadaOnChange: function (value, chave, campo) {
        // SETA O VALOR RECEBIDO
        this.campos.icone.habilitada[chave][campo].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.campos.icone.habilitada[chave][campo].mensagem = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // VERIFICA SE DEVE DAR FOCUS NO CAMPO
        if (campo === 'seletor' && (value === '0' || value.id === '0')) {
          if ([ '', null, undefined ].indexOf(this.campos.icone.habilitada[chave].input.value) !== -1) {
            // PEGA A DATA ATUAL
            var dataAtual = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY')

            // SOMA MAIS 7 DIAS
            var bloqueio = dataAtual.add(7, 'd')

            // A DATA DO BLOQUEIO SÓ PODE SER 2 = TERÇA, 3 = QUARTA, 4 = QUINTA, 5 = SEXTA
            while(bloqueio.day() <= 1 || bloqueio.day() >= 6) {
              bloqueio = bloqueio.add(1, 'd')
            }

            // SETA A DATA DO BLOQUEIO CALCULADA
            this.campos.icone.habilitada[chave].input.value = bloqueio.format('DD/MM/YYYY')
          }

          // DA O FOCUS NO CAMPO SOLICITADO
          // this.subaseGerTabIniciarEdicaoFocusCampo(chave + '_input')
        }
      },
      subaseGerHabilitadaSalvar: function (chave, clu) {
        // SETA O VALOR RECEBIDO
        this.campos.icone.habilitada[chave].salvar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA O FROMUALRIO
        var formData = { clu: clu, acao: this.campos.icone.habilitada[chave].seletor.value }

        // PEGAO VALOR SELECIONADO
        if (typeof formData.acao === 'object') {
          formData.acao = formData.acao.id
        }

        // VERIFICA A AÇÃO QUE DEVE SER FEITA
        switch (formData.acao) {
          case '1':
            formData.acao = 'l'
            break

          case '0':
            // SETA A AÇÃO DE BLOQUEIO
            formData.acao = 'b'

            // INFORMA A DATA DO BLOQUEIO
            formData.data = this.campos.icone.habilitada[chave].input.value
            break

          case '2':
            formData.acao = 'c'
            break
        }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/subase/painel/clu-alt-status', 'PUT', formData, (apiSuccess) => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

          // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
          this.subaseGerTabBuscarLinhas()
        }, this.subaseGerTabSetarStatusGeral, (apiValid, apiStatus) => { this.subaseGerTabTratarValidacao(chave, apiValid, apiStatus) })
      },
      subaseGerTabTratarValidacao: function (chave, apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos.icone.habilitada[chave], this).then(() => {
          // SETA O VALOR RECEBIDO
          this.campos.icone.habilitada[chave].salvar.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      subaseGerBloqueadaFrase: function (chave) {
        // INICIA A VARIAVEL PARA RETORNO
        var retorno = ''

        // VERIFICA SE TEM UMA DATA PARA COLOCAR NA MENSAGEM
        if ([ '', null, undefined ].indexOf(this.campos.icone.habilitada[chave].input.value) === -1) {
          // PEGA A DATA ATUAL
          var dataAtual = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY')
  
          // CONVERTE A DATA DO BLOQUEIO
          var bloqueio = moment(this.campos.icone.habilitada[chave].input.value, 'DD/MM/YYYY')
  
          // CALCULA A DIFERENÇA DAS DATAS
          var diff = bloqueio.diff(dataAtual, 'days')
  
          // INICIA A FRASE
          retorno = '<br/><div class="habilitada_frase">' + (diff > 0 ? 'O cliente será bloqueado após ' : '<span style="color: red;">O cliente está bloqueado hà ')
          
          // SETA O NUMERO DE DIAS
          retorno += (diff < 0 ? (diff * (-1)) : diff) + ' dia' + (diff > 1 ? 's' : '') + '.</span></div>'
        }

        // RETORNA O VALOR MONTADO
        return retorno
      }
    }
  }
</script>
